import { bindRequestLogic } from './utils'
import ShowcasePrivacyPolicyTypes from '../actionTypes/showcasePrivacyPolicy'
import { showcasePrivacyPolicyAPI } from '../api'

const updateShowcasePrivacyPolicy = bindRequestLogic({
  clientFunc: showcasePrivacyPolicyAPI.updateShowcasePrivacyPolicy,
  type: ShowcasePrivacyPolicyTypes.UPDATE_SHOWCASE_PRIVACY_POLICY_REQUEST,
  successType:
    ShowcasePrivacyPolicyTypes.UPDATE_SHOWCASE_PRIVACY_POLICY_SUCCESS,
  failType: ShowcasePrivacyPolicyTypes.UPDATE_SHOWCASE_PRIVACY_POLICY_FAILED
})

const getShowcasePrivacyPolicy = bindRequestLogic({
  clientFunc: showcasePrivacyPolicyAPI.getShowcasePrivacyPolicy,
  type: ShowcasePrivacyPolicyTypes.GET_SHOWCASE_PRIVACY_POLICY_REQUEST,
  successType: ShowcasePrivacyPolicyTypes.GET_SHOWCASE_PRIVACY_POLICY_SUCCESS,
  failType: ShowcasePrivacyPolicyTypes.GET_SHOWCASE_PRIVACY_POLICY_FAILED
})

export default [updateShowcasePrivacyPolicy, getShowcasePrivacyPolicy]
